import React, { useState, useContext, useEffect, useCallback } from 'react';
import { Grid, Button, Typography } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import * as Constants from '../Constants';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContextProvider';
import { rpc } from '../utils/RpcUtils';
import '../App.css';

const PhotoList = () => {
  const [photos, setPhotos] = useState([]);
  const [removed, setRemoved] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const fetchPhotos = async () => {
    const params = {
      _site: user._site._id,
    };
    if (user.caringFor) {
      params._shownTo = user.caringFor._id;
    } else {
      params._shownTo = null;
    }
    rpc({
      method: "GetPhotos",
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess: setPhotos
    });
  };
  const fetch = useCallback(fetchPhotos, [user]);

  useEffect(() => {
    fetch();
  }, [fetch]);
  
  const onSuccess = async () => {
    setRemoved([]);
    fetchPhotos();
  }; 

  const deletePhotos = async () => {
    console.log('onClick:', removed);
    const params = {
      ids: removed
    };
    rpc({
      method: "DeletePhotos",
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess: onSuccess
    });
  };

  const uploadPhotos = () => {
    navigate('/uploadPhotos');
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  const handleClick = (imageId) => {
    setRemoved(prev => {
      const lremoved = [...prev];
      const index = lremoved.indexOf(imageId);
      if (index !== -1) {
        lremoved.splice(index, 1);
      } else {
        lremoved.push(imageId);
      }
      return lremoved;
    });
  };

  const getImageSrc = (image) => {
    if (removed.includes(image._id)) {
      return '/big-red-x.png';
    }
    return `/itvs-site/${image.photoPath}`;
  };

  const ImageGrid = () => {
    return (
      <Grid container spacing={2}>
        {photos.map((image) => (
          <Grid item key={image._id} size={{ xs: 6, sm: 4, md: 3, lg: 2 }}>
            <img src={getImageSrc(image)} alt={image.photoPath}
              style={{ cursor: 'pointer', width: '100%', height: '140px' }} 
              onClick={() => handleClick(image._id)}/>
          </Grid>
        ))}
      </Grid>
    );
  };
        
  if (user.roles.includes(Constants.ROLE_FAMILY_MEMBER) && !user.caringFor) {
    return (
      <div className="PhotoList">
        <Typography variant="h6" gutterBottom>
          <a href = "../home">Select a user</a>
        </Typography>
      </div>
    );
  }

  return (
    <div className="PhotoList">
      <Typography variant="h6" gutterBottom>
        Photos {user.caringFor ? `for ${user.caringFor.first} ${user.caringFor.last}` : 
          `for ${user._site.name}`}
      </Typography>
      <div className="HorizontalContainer">
        <Button className="Button" variant="contained" color="primary" onClick={uploadPhotos}>
          Upload
        </Button>
        <Button className="Button" variant="outlined" color="error" onClick={deletePhotos} disabled={removed.length === 0}>
          Delete
        </Button>
      </div>
      <ImageGrid/>
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default PhotoList;
